module.exports = __webpack_public_path__ + "static/media/view3.91401eaa.jpg";